(function () {
    'use strict';

    angular
        .module('app')
        .controller('SaveItemDialogCtrl', SaveItemDialogCtrl);

    SaveItemDialogCtrl.$inject = ['DialogInstance', 'name', 'operation'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog used to prompt the user if they wish to save the specified ChilliDocs item (e.g. workflow, document template) before running an operation.
     *
     * @param {string} name - Name of the ChilliDocs item
     * @param {string} operation - Name of operation that user invoked which caused this dialog to be shown.
     *
     * @returns {promise} A promise that resolves if the user selects ok otherwise rejects.
     */
    function SaveItemDialogCtrl(DialogInstance, name, operation) {
        /* jshint validthis:true */
        var vm = this;
        vm.cancel = cancel;
        vm.ok = ok;
        vm.name = name;
        vm.operation = operation;

        function cancel() {
            DialogInstance.cancel();
        }

        function ok() {
            DialogInstance.ok();
        }
    }
})();
